export const environment = {
  name: 'production',
  production: true,
    auth: {
    url:
      'https://mb-file-uploader-users.auth.us-east-1.amazoncognito.com',
    callbackUrl: 'https://file-uploader.montebravo.com.br/auth',
    region: 'us-east-1',
    userPoolId: 'us-east-1_upccu4hhZ',
    userPoolWebClientId: '6e75h8g3hkrps9q73g4983ef6k',
  },
  apiUrl: 'https://file-uploader.api.montebravo.com.br/api',
  features: {
    /** Use here to define feature toggles */
  },
}
